import { format } from "date-fns";
import ru from "date-fns/locale/ru";
import { parseMockDate } from "../../OperationsJournal/mock/operationsJournalMock";
import { BASE_METHOD_BY_ID, distributeAmount, getBaseLabel } from "./allocationBase";

export const formatAllocationDocument = (id) => `R-${String(id).padStart(5, "0")}`;

const getMonthLabel = (date) => {
  const label = format(date, "LLLL yyyy", { locale: ru });
  return label.charAt(0).toUpperCase() + label.slice(1);
};

/** Период исходных операций: «Август 2026» или «Ноябрь 2025 – Январь 2026» */
export const getOperationsPeriod = (operations) => {
  if (!operations.length) return "—";
  const dates = operations.map((operation) => parseMockDate(operation.date));
  const from = getMonthLabel(new Date(Math.min(...dates)));
  const to = getMonthLabel(new Date(Math.max(...dates)));
  return from === to ? from : `${from} – ${to}`;
};

/**
 * Запись реестра распределений.
 * Каждая исходная операция делится между проектами по долям — получается
 * по одной управленческой проводке на пару «исходная операция — проект».
 * params хранит исходные параметры, чтобы запись можно было перезапустить.
 */
export const buildAllocationRecord = ({
  id,
  date,
  time,
  author,
  operations,
  allocation,
  base,
  restarted = false,
}) => {
  const document = formatAllocationDocument(id);
  const shares = allocation.rows.map((row) => row.share);

  const entries = operations.flatMap((operation) => {
    const amounts = distributeAmount(operation.amount, shares);
    return allocation.rows.map((row, index) => ({
      id: `${operation.id}-${row.project.id}`,
      sourceDocument: operation.document,
      sourceDate: operation.date,
      project: row.project,
      share: row.share,
      amount: amounts[index],
    }));
  });

  return {
    id,
    document,
    date,
    launchedAt: time ? `${date} ${time}` : date,
    author,
    period: getOperationsPeriod(operations),
    baseShort: BASE_METHOD_BY_ID[base.method].shortTitle,
    baseLabel: getBaseLabel(base),
    operationsCount: operations.length,
    recipientsCount: allocation.rows.length,
    total: operations.reduce((sum, operation) => sum + operation.amount, 0),
    restarted,
    rows: allocation.rows,
    entries: entries.map((entry, index) => ({
      ...entry,
      document: `${document}/${index + 1}`,
    })),
    params: {
      operations,
      projectIds: allocation.rows.map((row) => row.project.id),
      base,
    },
  };
};
